import history from "history.js";
import { useEffect } from "react";
import { Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../styles/_app.scss";
import "../styles/nprogress.css";
import AppProvider from "./AppProvider";
import { APPOINTMENT_PATH, LOGOUT_LOG_BROWSER } from "./appConfig";
import Auth from "./auth/Auth";
import Public from "./auth/Public";
import LayoutContainer from "./common/Layout/LayoutContainer";
import UserService from "./services/UserService";

// loadProgressBar();
const App = () => {
  const isSpecialUrl = window.location.pathname;
  useEffect(() => {
    const threshold = 160;
    const interval = setInterval(() => {
      if (
        (window.outerWidth - window.innerWidth > threshold ||
          window.outerHeight - window.innerHeight > threshold) &&
        LOGOUT_LOG_BROWSER
      ) {
        console.log("⚠️ DevTools detected!");
        localStorage.removeItem("auth_token");
        localStorage.removeItem("jwt_token");
        localStorage.removeItem("auth_user");

        UserService.doLogout();

        caches.keys().then((keys) => keys.forEach((key) => caches.delete(key)));
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <AppProvider>
      {!(isSpecialUrl === "/" + APPOINTMENT_PATH) ? (
        <Router history={history}>
          <Auth>
            <ToastContainer
              limit={1}
              newestOnTop
              pauseOnHover={false}
              pauseOnFocusLoss={false}
              autoClose={2000}
            />
            <LayoutContainer />
          </Auth>
        </Router>
      ) : (
        <Router history={history}>
          <Public>
            <ToastContainer
              limit={1}
              newestOnTop
              pauseOnHover={false}
              pauseOnFocusLoss={false}
              autoClose={2000}
            />
            <LayoutContainer />
          </Public>
        </Router>
      )}
    </AppProvider>
  );
};

export default App;
